import React from "react";

export const DotIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g id="dot-icon">
      <circle id="Vector" cx="12" cy="12" r="2" fill={color || "#253858"} />
    </g>
  </svg>
);
